import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurvedArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 144,
	height: 35,
	viewBox: "0 0 144 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_13544_31071)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1.53185 15.4061C6.42762 19.7513 11.0108 24.4062 15.279 29.369C17.2869 31.7039 20.7847 28.4571 18.7859 26.1325C15.8119 22.6749 12.6815 19.37 9.40246 16.2115C41.9316 22.6511 75.5282 22.9003 108.139 16.831C117.424 15.1029 126.602 12.8485 135.643 10.1158C138.567 9.2318 137.493 4.5802 134.543 5.47238C103.419 14.8807 70.6552 18.3221 38.2547 15.5409C30.6887 14.8913 23.1616 13.892 15.6884 12.5637C17.2139 12.0895 18.7381 11.6109 20.2595 11.1248C23.1643 10.196 22.0944 5.54299 19.1602 6.48117C13.7096 8.22353 8.23478 9.88545 2.73549 11.4663C1.17143 11.9157 0.108347 14.1428 1.53185 15.4061Z",
				fill: "#817BD7"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_13544_31071",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 144,
				height: 35,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCurvedArrow);
export default ForwardRef;
